import React, { Component, useEffect, useState } from 'react';
import { Form } from 'reactstrap';
import CustomModal from '../../CustomModal/CustomModal';
import { Alert, Col } from 'reactstrap';
import cx from 'classnames';
import StoackGudangListTable from './StoackGudangListTable';
import StockListTable from './StockListTable';

import s from '../Users.module.scss';

const StockPage = () => {
  const [promoAlert, setPromoAlert] = useState(false);

  const showPromoAlert = () => setPromoAlert(true);

  const [puskemasKu, setPuskesmasKu] = useState('');
  const [unitKu, setUnitKu] = useState('');
  const [levelKu, setLevelKu] = useState('');

  useEffect(() => {
    setTimeout(() => {
      showPromoAlert();
    }, 100);
  });

  return (
    <div>
      <div className='page-top-line'>
        <Col>
          {levelKu == 'Puskesmas' ? (
            <h2 className='page-title'>
              Manajemen <span className='fw-semi-bold'>Stock </span> Puskesmas{' '}
              <code>{puskemasKu}</code>
            </h2>
          ) : (
            <h2 className='page-title'>
              Manajemen <span className='fw-semi-bold'>Stock </span>{' '}
              <code>{unitKu}</code> Puskesmas <code>{puskemasKu}</code>
            </h2>
          )}
        </Col>
        <Alert
          color='primary'
          className={cx(s.promoAlert, { [s.showAlert]: promoAlert })}
        >
          Aplikasi ini terintegrasi ke{' '}
          <a
            className='text-white font-weight-bold'
            rel='noreferrer noopener'
            href=''
            target='_blank'
          >
            Rote Smart Service
          </a>{' '}
          integration!
        </Alert>
      </div>
      <StockListTable
        setLevelKu={setLevelKu}
        setUnitKu={setUnitKu}
        setPuskesmasKu={setPuskesmasKu}
      />
    </div>
  );
};

export default StockPage;
